import _get from 'lodash/get';

import {
  BASE_SINGLE_IMAGE_CONTENT_CSS_RULES,
  BASE_SINGLE_IMAGE_BACKGROUND_CSS_RULES,
  BASE_SINGLE_IMAGE_CSS_RULES,
  BASE_SINGLE_IMAGE_GATSBY_CSS_RULES,
  SINGLE_IMAGE_CONTENT_CSS_RULES,
  SINGLE_IMAGE_CSS_RULES_BY_RECIPE,
} from './SingleImageStyle.constants';

export function getContentImageCSSRules(recipeName) {
  return [
    ...BASE_SINGLE_IMAGE_CONTENT_CSS_RULES,
    ..._get(SINGLE_IMAGE_CONTENT_CSS_RULES, recipeName, []),
  ];
}

export function getSingleImageCSSRules(recipeName, isBackground = false) {
  const baseRules = isBackground
    ? BASE_SINGLE_IMAGE_BACKGROUND_CSS_RULES
    : BASE_SINGLE_IMAGE_GATSBY_CSS_RULES;
  return [
    ...BASE_SINGLE_IMAGE_CSS_RULES,
    ...baseRules,
    ..._get(SINGLE_IMAGE_CSS_RULES_BY_RECIPE, recipeName, []),
  ];
}
